export const rowToCard = r => ({
  ...r,
  id: r.id,
});

export function buildColumnsByUnitOperation(unitOperations = [], items = []) {
  // Creating columns by unitOperation
  const colsById = unitOperations.reduce((acc, op) => {
    acc[op.id] = {
      ...op,
      id: op.id,
      cards: [],
    };
    return acc;
  }, {});

  // Adding cards to columns
  items.reduce((acc, r) => {
    const opId = r?.id_unitary_operation;
    const col = acc[opId];
    if (!col) return acc;
    col.cards = col.cards.concat(rowToCard(r));
    return acc;
  }, colsById);

  // Ordering cards by priority
  Object.values(colsById).forEach((col) => {
    col.cards.sort((a, b) => (a.priority ?? 0) - (b.priority ?? 0));
  });

  // Ordering colums by order to garantee unit operation sequence
  return Object.values(colsById).sort((a, b) => a.order - b.order);
}

export function rowsToColumns(rows = []) {
  const byOp = rows.reduce((acc, r) => {
    const opId = r.id_unitary_operation;
    if (!acc[opId]) {
      acc[opId] = {
        id: `col-${opId}`,
        title: r.unitary_operation_name || `Operação ${opId}`,
        unitOperationGroupId: r.id_unitary_operation_group,
        unitOperationId: opId,
        order: r.order,
        cards: [],
      };
    }
    acc[opId].cards.push(rowToCard(r));
    return acc;
  }, {});

  return Object.values(byOp).sort((a, b) => a.title.localeCompare(b.title));
}
